// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2sGiL","savePackageButton":"ClientWallet_savePackageButton__1OwxG"};